// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputContainer_M5O_V input[type="file"] {
  display: none;
}

.inputContainer_M5O_V {
  width: 100%;
  height: 100%;
}

.inputContainer_M5O_V label {
  height: 100%;
  width: 100%;
  color: var(--_646e8a-color);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  background: var(--white-background);
  border-radius: 20px;
  p {
    margin: 0;
    font-weight: 600;
    color: var(--black-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/SkeletonScreen/SkeletonScreen.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB;IACE,SAAS;IACT,gBAAgB;IAChB,yBAAyB;EAC3B;AACF","sourcesContent":[".inputContainer input[type=\"file\"] {\n  display: none;\n}\n\n.inputContainer {\n  width: 100%;\n  height: 100%;\n}\n\n.inputContainer label {\n  height: 100%;\n  width: 100%;\n  color: var(--_646e8a-color);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  background: var(--white-background);\n  border-radius: 20px;\n  p {\n    margin: 0;\n    font-weight: 600;\n    color: var(--black-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `inputContainer_M5O_V`
};
export default ___CSS_LOADER_EXPORT___;
